module.exports = __webpack_public_path__ + "static/media/446035398_301148996402085_7567450736841955004_n (1).e480f193.jpg";